import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { BlurredTranscript } from './BlurredTranscript';
import { TurnOnTranscriptionButton } from '../../shared/TurnOnTranscriptionButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TranscriptSettingsDisabledAdminEmptyState = () => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "transcriptSettingsDisabled-adminEmptyState",
    children: [/*#__PURE__*/_jsx(TurnOnTranscriptionButton, {}), /*#__PURE__*/_jsx(BlurredTranscript, {})]
  });
};
export const TranscriptSettingsDisabledNonAdminEmptyState = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    "data-test-id": "transcriptSettingsDisabled-nonAdminEmptyState",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "calling-transcript",
      marginInline: "300",
      marginBlockStart: "200",
      width: "35%"
    }), /*#__PURE__*/_jsx(Text, {
      as: "div",
      textAlign: "center",
      paddingBlockStart: "300",
      children: /*#__PURE__*/_jsx("p", {
        "data-test-id": "transcript-admin-message",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'recordingReviewComponents.transcript.transcriptEmptyStates.transcriptSettingsDisabled.isNotAdmin.description'
        })
      })
    })]
  });
};